import { ExternalLink, MapPin, Instagram } from "lucide-react";
import { DORIE_URL, NAV_LINKS, PHONE_DISPLAY, MAPS_URL, INSTAGRAM_URL } from "../constants";

export const Footer = ({ onOpenCertificates, onOpenLegal }) => (
    <footer
        data-testid="site-footer"
        className="bg-miam-dark pb-28 pt-16 text-miam-cream md:pb-16"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
                <div className="max-w-sm">
                    <div className="flex items-center gap-4">
                        <img
                            src="/miamo-clinic-logo.png"
                            alt="شعار عيادة ميامو الرسمي"
                            data-testid="footer-logo"
                            className="h-20 w-auto object-contain"
                        />
                        <div>
                            <p className="font-heading text-xl font-bold">
                                ميام – مساحة شفاء ووعي
                            </p>
                        </div>
                    </div>
                    <p className="mt-5 text-sm leading-relaxed text-miam-cream/70">
                        <a
                            href={MAPS_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-maps-link"
                            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-miam-green"
                        >
                            <MapPin className="h-4 w-4" aria-hidden="true" />
                            يركا، بالقرب من مدرسة الأمل
                        </a>
                    </p>
                    <p className="mt-2 text-sm text-miam-cream/70">
                        هاتف وواتساب:{" "}
                        <span dir="ltr" data-testid="footer-phone">
                            {PHONE_DISPLAY}
                        </span>
                    </p>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram-link"
                        aria-label="إنستغرام ميام"
                        className="mt-5 inline-flex items-center gap-2.5 rounded-full border border-miam-cream/25 px-5 py-2.5 text-sm font-bold text-miam-cream/85 transition-[background-color,color,border-color] duration-300 hover:border-miam-rose hover:bg-miam-rose hover:text-white"
                    >
                        <Instagram className="h-4 w-4" aria-hidden="true" />
                        تابعينا على إنستغرام
                    </a>
                </div>

                <nav aria-label="روابط التذييل" data-testid="footer-nav">
                    <ul className="flex flex-wrap gap-x-6 gap-y-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.id}>
                                {link.id === "certificates" ? (
                                    <button
                                        type="button"
                                        data-testid="footer-link-certificates"
                                        onClick={onOpenCertificates}
                                        className="text-sm text-miam-cream/80 transition-colors duration-300 hover:text-miam-green"
                                    >
                                        {link.label}
                                    </button>
                                ) : (
                                    <a
                                        href={`#${link.id}`}
                                        data-testid={`footer-link-${link.id}`}
                                        className="text-sm text-miam-cream/80 transition-colors duration-300 hover:text-miam-green"
                                    >
                                        {link.id === "packages" ? "الأسعار" : link.label}
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                    <a
                        href={DORIE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-dorie-link"
                        className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-miam-green transition-colors duration-300 hover:text-miam-cream"
                    >
                        حجز المواعيد عبر دُوري
                        <ExternalLink className="h-4 w-4" aria-hidden="true" />
                    </a>
                </nav>
            </div>

            <div className="mt-12 border-t border-miam-cream/15 pt-8">
                <p
                    data-testid="footer-disclaimer"
                    className="text-xs leading-relaxed text-miam-cream/60"
                >
                    الخدمات المقدّمة تهدف إلى دعم الراحة والعافية، ولا تُعد
                    بديلاً عن التشخيص أو الاستشارة الطبية عند الحاجة.
                </p>
                <p
                    data-testid="footer-credit"
                    className="mt-6 text-xs leading-relaxed text-miam-cream/50"
                >
                    تم تصميم وبناء هذا الموقع بيد رندة بدر — مصممة جرافيك
                    وبناء مواقع. للحصول على عرض لبناء موقعك:{" "}
                    <a
                        href="mailto:baderranda288@gmail.com"
                        data-testid="footer-credit-email"
                        className="font-bold text-miam-cream/70 underline decoration-miam-green/50 underline-offset-4 transition-colors duration-300 hover:text-miam-green"
                    >
                        baderranda288@gmail.com
                    </a>
                </p>
                <div
                    data-testid="footer-legal-links"
                    className="mt-5 flex flex-wrap gap-x-6 gap-y-2"
                >
                    <button
                        type="button"
                        onClick={() => onOpenLegal("terms")}
                        data-testid="footer-legal-terms"
                        className="text-xs text-miam-cream/60 transition-colors duration-300 hover:text-miam-green"
                    >
                        شروط الاستخدام
                    </button>
                    <button
                        type="button"
                        onClick={() => onOpenLegal("privacy")}
                        data-testid="footer-legal-privacy"
                        className="text-xs text-miam-cream/60 transition-colors duration-300 hover:text-miam-green"
                    >
                        سياسة الخصوصية
                    </button>
                    <button
                        type="button"
                        onClick={() => onOpenLegal("accessibility")}
                        data-testid="footer-legal-accessibility"
                        className="text-xs text-miam-cream/60 transition-colors duration-300 hover:text-miam-green"
                    >
                        بيان إمكانية الوصول
                    </button>
                </div>
            </div>
        </div>
    </footer>
);
